import { makeAutoObservable } from 'mobx';

import { DriveItemType, FolderItem } from '@/drive/entities/DriveItem/DriveItem';
import { DriveItemId } from '@/drive/entities/DriveItemId';
import { DriveFolderOutline } from '@/drive/entities/DriveNode';
import { DriveTreeItem, fromDriveNode } from '@/drive/entities/DriveTreeItem/DriveTreeItem';
import { getDriveFolderUrl } from '@/drive/utils/getDriveFolderUrl';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';
import { ProjectDataAccess } from '@/security/types/DataAccess';

export class FolderTreeItem implements DriveTreeItem {
  id!: DriveItemId;
  title: string;

  count!: number;
  children: DriveTreeItem[];
  description?: string;
  access!: GlobalAccessLevel;
  dataAccess!: ProjectDataAccess;
  canEdit!: boolean;
  canManageAccess!: boolean;
  collapsed = true;

  constructor(item: DriveFolderOutline | FolderItem) {
    makeAutoObservable(this, {
      id: false,
      count: false,
      children: false,
      description: false,
      access: false,
      dataAccess: false,
      canEdit: false,
      canManageAccess: false,
    });

    this.id = item.id;
    this.title = item.title;
    this.count = item.count;
    this.description = item.description;
    this.access = item.access;
    this.dataAccess = item.dataAccess;
    this.canEdit = item.canEdit;
    this.canManageAccess = item.canManageAccess;
    this.children = 'children' in item ? item.children.map(fromDriveNode) : [];
  }

  setTitle(title: string) {
    this.title = title;
  }

  getUrl() {
    return getDriveFolderUrl(this.id);
  }

  getDriveId() {
    return this.id;
  }

  getAccess() {
    return this.access;
  }

  toDriveItem(): FolderItem {
    return new FolderItem({
      id: this.id,
      type: DriveItemType.Folder,
      title: this.title,
      count: this.count,
      description: this.description,
      access: this.access,
      dataAccess: this.dataAccess,
      canEdit: this.canEdit,
      canManageAccess: this.canManageAccess,
    });
  }
}
